import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { defineMessages, FormattedMessage } from "react-intl";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { CreditCardTypeAPIPromiseClient } from "../../../../gen/witbooking/backoffice/payment/v1/payment_api_grpc_web_pb";
import {
  EnableCreditCardRequest,
  GetCreditCardsRequest,
} from "../../../../gen/witbooking/backoffice/payment/v1/payment_api_pb";

const messages = defineMessages({
  creditCards: {
    id: "app.creditCardList.creditCards",
    description: "Credit Cards",
    defaultMessage: "Credit Cards",
  },
});
const Container = styled.div`
  padding: 0 20px 30px;
`;

const Table = styled.div`
  width: 100%;
  max-width: 600px;
  font-family: "Source Sans Pro", sans-serif;
  color: #656565;
`;

const TableHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  border-bottom: 1px solid rgb(238, 238, 238);
  background-color: rgb(250, 251, 252);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 14px;
`;

const TableRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 45px;
  padding: 0 10px;
  border-bottom: 1px solid rgb(238, 238, 238);

  &:nth-child(even) {
    background-color: rgb(250, 251, 252);
  }

  label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0;
    font-weight: normal;
    cursor: pointer;
  }
`;

const ActiveCheckBoxContainer = styled.div`
  margin-right: 30px !important;
`;

const SuccessMessage = styled.div`
  margin-top: 20px;

  .alert {
    margin-bottom: 0;
  }
`;

function CreditCardList(props) {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [creditCardList, setCreditCardList] = useState([]);

  const creditCardClient = useGrpcClient(CreditCardTypeAPIPromiseClient);
  const getCreditCards = usePropertyGrpcCall(creditCardClient, creditCardClient.getCreditCards);
  const enableCreditCard = usePropertyGrpcCall(creditCardClient, creditCardClient.enableCreditCard);

  const handleChange = useCallback(
    selectedCreditCard => {
      const newList = [...creditCardList];
      newList[selectedCreditCard].active = !creditCardList[selectedCreditCard].active;
      setCreditCardList(newList);
      setShowSuccessMessage(false);

      const request = new EnableCreditCardRequest();
      request.setCardId(newList[selectedCreditCard].id);
      request.setEnable(newList[selectedCreditCard].active);

      enableCreditCard(request).then(() => {
        setShowSuccessMessage(true);
      });
    },
    [creditCardList, enableCreditCard]
  );

  useEffect(() => {
    getCreditCards(new GetCreditCardsRequest()).then(response =>
      setCreditCardList(
        response.getCreditCardsList().map(cc => ({
          id: cc.getId(),
          active: cc.getEnabled(),
          name: cc.getName(),
        }))
      )
    );
  }, [getCreditCards]);

  return (
    <Container>
      <Table>
        <TableHeader>
          {" "}
          <FormattedMessage {...messages.creditCards} />
        </TableHeader>

        <div>
          {Object.keys(creditCardList).map(code => (
            <TableRow key={code}>
              <label>
                <ActiveCheckBoxContainer className="checkbox c-checkbox needsclick">
                  <label className="needsclick">
                    <input
                      type="checkbox"
                      className="needsclick"
                      value="on"
                      checked={creditCardList[code].active}
                      onChange={() => handleChange(code)}
                    />
                    <em className="fa fa-check fa-checked" />
                  </label>
                </ActiveCheckBoxContainer>

                <div>{creditCardList[code].name}</div>
              </label>
            </TableRow>
          ))}
        </div>
      </Table>

      {showSuccessMessage && (
        <SuccessMessage>
          <div role="alert" className="alert alert-success">
            <strong>Update Successful!</strong>
          </div>
        </SuccessMessage>
      )}
    </Container>
  );
}

export default CreditCardList;
